module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921035651_T.4f630f30.jpg";